import { Children, Component, ReactElement, }  from "react";
import { Select, TextInput, classNames, parseClasses, } from ".";

export enum SelectInputMode {
    Select = 0,
    Input,
}

interface Props {
    value: number | string | undefined;
    name?: string;
    className?: string | string[];
    disabled?: boolean;
    readonly?: boolean;
    focused?: boolean;
    placeholder?: string;
    mode?: SelectInputMode;

    onSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onInputClear: () => void;
    onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;

    children?: React.ReactNode;
}

interface State {

}

export class SelectInput extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    public render(): ReactElement {
        const {
            value,
            name,
            className,
            disabled,
            readonly,
            focused,
            placeholder,
            onSelectChange,
            onInputChange,
            onInputClear,
            mode,
        } = this.props;

        const css = classNames([
            parseClasses(className),
            "__selectinput__",
        ]);

        // render the select element by default
        if (mode === SelectInputMode.Select || value === undefined) {
            return (
                <Select
                    name={name}
                    value={value === undefined ? "" : value.toString()}
                    className={css}
                    disabled={disabled}
                    readonly={readonly}
                    focused={focused}
                    onChange={onSelectChange}
                >
                    {this.props.children}
                </Select>
            );
        }

        // otherwise render the text input
        const isReadOnly = readonly || onInputChange === undefined;

        return (
            <TextInput
                name={name}
                value={value === undefined ? "" : value.toString()}
                className={css}
                placeholder={placeholder}
                disabled={disabled}
                readonly={isReadOnly}
                focused={value === undefined}
                onChange={onInputChange}
                onClear={onInputClear}
            />
        );
    }

    private _shouldRenderSelect(): boolean {
        const { value, children, } = this.props;

        // if the value is undefined, we want to render the default control;
        // here it's the select component
        if (value === undefined || value === null) {
            return true;
        }

        if (!children) {
            return false;
        }

        const c = Children.toArray(children);

        const match = c.find(child => {
            const v = (child as ReactElement)!.props!.value;
            return v === value;
        });

        return !!match;
    }
}